import * as React from 'react';
import styled from 'styled-components';

export class BannerGridItem extends React.Component {
  render() {
    return <HomepageItem>{this.props.children}</HomepageItem>;
  }
}

const HomepageItem = styled.div`
  flex-basis: 66.6%;

  @media only screen and (max-width: 600px) {
    flex-basis: 100%;
  }
`;
